import { createBrowserRouter, Navigate } from 'react-router';

import { RequireAuthLayout } from '@/features/auth/require-permission';
import { RootLayout } from '@/layouts/root-layout';
import { LoginPage } from '@/pages/login-page';
import { EinrichtenPage } from '@/platform/pages/einrichten-page';
import { NotFoundPage } from '@/pages/not-found-page';
import { platformLegacyRedirectRoutes, platformRoute } from '@/platform/routes';
import { LegacyHelpdeskRedirect } from '@/products/helpdesk/legacy-helpdesk-redirect';
import {
  helpdeskAgentRoute,
  helpdeskLegacyRedirectRoutes,
  helpdeskPortalRoute,
  helpdeskTokenRoutes,
} from '@/products/helpdesk/routes';
import { fleetRoute } from '@/products/fleet/routes';
import { intranetRoute } from '@/products/intranet/routes';
import { leaveRoute } from '@/products/leave/routes';
import { maintenanceRoute } from '@/products/maintenance/routes';
import { onboardingRoute } from '@/products/onboarding/routes';

export const router = createBrowserRouter([
  helpdeskPortalRoute,
  /* Mitarbeiterportal (`/start`, Verwaltung). Home and logo go to `/start` (§7.2). */
  platformRoute,
  intranetRoute,
  leaveRoute,
  fleetRoute,
  maintenanceRoute,
  onboardingRoute,
  ...platformLegacyRedirectRoutes,
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: LegacyHelpdeskRedirect },
      { path: 'anmelden', Component: LoginPage },
      { path: 'einrichten', Component: EinrichtenPage },
      {
        path: 'einstellungen',
        Component: RequireAuthLayout,
        children: [{ index: true, element: <Navigate to="/profil" replace /> }],
      },
      helpdeskAgentRoute,
      ...helpdeskTokenRoutes,
      ...helpdeskLegacyRedirectRoutes,
      { path: '*', Component: NotFoundPage },
    ],
  },
]);
